import * as Yup from 'yup';

import { alphabets, alphaNumeric, numbers } from '@utils/regex';
import YupUtil from '@utils/YupUtil';

export const ContactFormSchema = Yup.object().shape({
    name: YupUtil.getStringTrimmedScheme('name', 'Name', true, 3, 20, alphabets),
    subject: YupUtil.getStringTrimmedScheme('subject', 'Subject', true, 3, 50, alphaNumeric),
    email: YupUtil.getEmailScheme('email', 'Email', true),
    phone: YupUtil.getStringTrimmedScheme('phone', 'Phone', true, 10, 16, numbers),
    description: YupUtil.getStringTrimmedScheme('description', 'Description', true, 10, 100),
});
